<template>
<div>
  <!-- Details List -->
  <form-accordion :title="ServiceDetails" v-if="showMainDetails">
    <div class="row">
      <form-read-group-label-input
        :inputLabel="$t('common.rsn')" :inputValue="invoice.NameSeller">
      </form-read-group-label-input>
      <form-read-group-label-input
        :inputLabel="$t('common.idtfr')" :inputValue="invoice.InvoiceIdentifier">
      </form-read-group-label-input>
    </div>
    <!-- TLV 25/09/2020 : On affiche le nom et l'e-mail du créancier si c'est le créancier
    (le destinataire du DP) qui regarde. Si le débiteur (l'expéditeur du DP)
    regarde, on affiche le nom et l'e-mail du débiteur -->
    <div class="row">
      <template v-if="invoice.direction === '1'">
        <form-read-group-label-input
          :inputLabel="$t('common.crdtr_name')"
          :inputValue="invoice.creditorName">
        </form-read-group-label-input>
        <form-read-group-label-input
          :inputLabel="$t('common.crdtr_mail')"
          :inputValue="invoice.creditorIdentifier">
        </form-read-group-label-input>
      </template>
      <template v-else-if="invoice.direction === '0'">
        <form-read-group-label-input
          :inputLabel="$t('common.debtor_name')"
          :inputValue="invoice.debtorName">
        </form-read-group-label-input>
        <form-read-group-label-input
          :inputLabel="$t('common.debtor_email')"
          :inputValue="invoice.debtorIdentifier">
        </form-read-group-label-input>
      </template>
    </div>

    <div class="row">
      <!-- Affichage IBAN, ou Sort Code & accountNumber, etc -->
      <template
        v-for="accountData in bankLabelHidden(invoice.creditorBankAccount, invoice.creditorZoneCode)">
        <form-read-group-label-input :key="accountData.hiddenValue"
          :inputLabel="invoice.direction === '1' ? $t(accountData.labelId + '_creditor') : $t(accountData.labelId + '_my')"
          :inputValue="accountData.hiddenValue">
        </form-read-group-label-input>
      </template>
      <template
        v-for="debtorAccountData in bankLabelHidden(invoice.debtorBankAccount, invoice.debtorZoneCode)">
        <form-read-group-label-input :key="debtorAccountData.hiddenValue"
          :inputLabel="invoice.direction === '0' ? $t(debtorAccountData.labelId + '_debtor') : $t(debtorAccountData.labelId + '_my')"
          :inputValue="debtorAccountData.hiddenValue">
        </form-read-group-label-input>
      </template>
    </div>

    <div class="row">
      <form-read-group-label-input
        inputLabel="Date de création du paiement" :inputValue="invoice.PaymentDate | formatDate">
      </form-read-group-label-input>
      <form-read-group-label-input
        :inputLabel="$t('common.status.status_label')"
        :inputValue="getStatusLabel(invoice.Status, invoice.direction)"
        :statusIcon="getIcon(invoice.Status, '0')">
      </form-read-group-label-input>
    </div>

    <div class="row">
      <form-read-group-label-input
        :inputLabel="$t('common.total_amount_no_currency')"
        :inputValue="invoice.Amount + ' ' + getCurrencyIcon(invoice.currency)">
      </form-read-group-label-input>
      <div class="form-group col-sm-6"
        v-if="invoice.attachmentId !== ''">
        <div class="" :class="colorBottomButton">
          <button round
            @click="view(invoice.attachmentId)"
            class="button-action firstButtonMarginTop"
            v-if="ifAndroid">
            <i class="icon fa fa-paperclip"></i>
            {{ $t('creation_forms.view_attchmnt') }}
          </button>
          <button round
            v-if="!ifAndroid"
            @click="view(invoice.attachmentId)"
            class="milkyBlockBlack button-action firstButtonMarginTop">
              <i class="icon fa fa-paperclip"></i>
              {{ $t('creation_forms.dwnld_attchmnt') }}
          </button>
        </div>
      </div>
      <form-read-group-label-input
        inputLabel="Date d'exécution" :inputValue="invoice.PaymentDate | formatDate">
      </form-read-group-label-input>
    </div>

    <b-row class="mt-2" v-if="[status.MADE, status.INST_MADE].includes(invoice.Status)">
      <b-col cols="12" class="transactionDetailSubHeader">
        {{ "Lettrage" }}
      </b-col>
      <b-col cols="12" class="mt-2">
        {{ invoice.lettrage && invoice.lettrage.length > 0 ? formatLettrage(invoice.lettrage) : 'Pas de lettrage' }}
      </b-col>
    </b-row>
  </form-accordion>

  <hr v-if="showMainDetails"/>

  <!-- History -->
  <form-accordion :title="$t('common.formsSubTitle.trnsctns_hstry')">
    <div v-if="invoice.History && invoice.History.length > 0">
      <!-- <div class="form-group row col-sm-6" id="inst-invoice-opt">
        <b-form-checkbox
          v-model="invoice.instantPayment"
          value="1"
          unchecked-value="0"
          disabled>
          {{ $t('requestToPay.is_inst_payment') }}
        </b-form-checkbox>
      </div> -->
      <div class="form-group row">
        <div class="col-12">
          <table class="table table-striped table-bordered table-status-history">
            <thead class="thead-dark">
              <tr>
                <th scope="col" class="reponsiveColumnWidth">{{ $t('common.date_label') }}</th>
                <th scope="col">{{ $t('common.amnt') }}</th>
                <th scope="col">{{ $t('common.status.status_label') }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="record in invoice.History" :key="record.IdTransaction">
                <td class="dateTimehistoryHeight">{{ record.CreationDate | formatDateTime }}</td>
                <td>
                  <div class="row">
                    <div class="col-12 statusHistoryLabel">
                      {{ getDirectionIcon(record.Direction) + ' ' + record.Amount + ' ' + getCurrencyIcon(record.Currency) }}
                    </div>
                  </div>
                </td>
                <td>
                  <div class="row">
                    <div class="col-sm-7 statusHistoryLabel">
                      {{ getStatusLabel('Transaction_' + record.Status, '0') }}
                      <i :class="'icon icon-transaction-detail ' + getIcon('Transaction_' + record.Status)"></i>
                    </div>
                    <div class="col-sm-5">
                      <f7-button
                        class="xmlButtonBackground"
                        @click="viewXML()"
                        v-if="showPain001View(record)">
                        {{ $t('common.button_technical_details') }}
                      </f7-button>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div v-else style="text-align: center;background: #dcdcdc;">
      {{ $t('common.no_transaction_yet') }}
    </div>
  </form-accordion>
</div>
</template>

<script>
import FormAccordion from '@/components/common/FormAccordion.vue'
import formReadGroupLabelInput from '@/components/common/formReadGroupLabelInput.vue'
import status from '@/helpers/status'
import {statusLabel, statusIcon} from '@/helpers/labels'
import {errorMessageAlert} from '@/helpers/alert'
import {extractForeignIban, formatLettrage} from '@/helpers/format'
import moment from 'moment'
import b64toBlob from 'b64-to-blob'

export default {
  name: 'InvoiceDetailCapsule',
  props: ['invoice', 'showMainDetails'],
  components: {
    'form-accordion': FormAccordion,
    'form-read-group-label-input': formReadGroupLabelInput
  },
  data () {
    return {
      colorBottomButton: this.$engine.services.getButtonClassColorById(this.$engine.user.currentService.id),
      ServiceDetails: '',
      status: status
    }
  },
  created () {
    this.ServiceDetails = this.$i18n.t('common.item_details',
      {itemname: this.$i18n.t(this.$engine.services.getSingularNameFromServiceId(this.$engine.user.currentService.id))})
  },
  computed: {
    ifAndroid () {
      return this.$f7.device.os === 'android'
    }
  },
  methods: {
    formatLettrage: formatLettrage,
    bankLabelHidden (iban, zone) {
      return extractForeignIban(iban, zone)
    },
    checkForWritePermissions (sucess, error) {
      /* eslint-disable no-undef */
      if (this.$f7.device.os === 'android') {
        cordova.plugins.diagnostic.requestRuntimePermission(function (status) {
          switch (status) {
            case cordova.plugins.diagnostic.permissionStatus.GRANTED:
              console.log('Permission granted')
              sucess()
              break
            case cordova.plugins.diagnostic.permissionStatus.DENIED:
              console.log('Permission denied')
              error()
              break
            case cordova.plugins.diagnostic.permissionStatus.DENIED_ALWAYS:
              console.log('Permission permanently denied')
              error()
              break
          }
        }, function (error) {
          console.error('The following error occurred: ' + error)
        },
          cordova.plugins.diagnostic.permission.WRITE_EXTERNAL_STORAGE
        )
      } else if (this.$f7.device.os === 'ios') {
        sucess()
      }
      /* eslint-enable no-undef */
    },
    getCurrencyIcon (ccy) {
      switch (ccy) {
        case 'EUR':
          return '€'
        case 'USD':
          return '$'
        case 'AUD':
          return 'A$'
        case 'GBP':
          return '£'
        case 'JPY':
          return '¥'
        case 'RUB':
          return '₽'
        default:
          return ccy
      }
    },
    getDirectionIcon (direction) {
      switch (direction) {
        case 'C':
          return '+'
        case 'D':
          return '-'
        default:
          return '+'
      }
    },
    getIcon (status, negotStatus) {
      return statusIcon(status, negotStatus)
    },
    getStatusLabel (status, direction) {
      return statusLabel(this.$i18n, status, -1, direction)
    },
    readFile (filePath, fileType, fileName) {
      /* eslint-disable no-undef */
      // TODO : test fileType before trying to open and let the user know
      window.resolveLocalFileSystemURL(filePath, function (entry) {
        cordova.plugins.fileOpener2.open(entry.nativeURL.replace(/%20/g, ' '), fileType, {
          error: function (e) {
            // TODO : screen user stuff
          },
          success: function (s) {
            // TODO : screen user stuff
          }
        })
      })
    },
    saveFileToDirectory (fileName, data, fileType, directory, success, error) {
      /* eslint-disable no-undef */
      let directoryEntryReference = null
      window.resolveLocalFileSystemURL(directory, function (directoryEntry) {
        directoryEntryReference = directoryEntry
        directoryEntry.getFile(fileName, { create: true, exclusive: true }, function (fileEntry) {
          fileEntry.createWriter(function (fileWriter) {
            fileWriter.onwriteend = function (e) {
              success(e.target.localURL, fileType, fileName)
            }
            fileWriter.onerror = function (e) {
              error()
            }
            let blob = b64toBlob(data.replace(/^data:\w+\/\w+;base64,/, ''), fileType)
            fileWriter.write(blob)
          }, (e, file) => {
          })
        }, (e, file) => {
          navigator.notification.confirm('This file already exists do you want to override it ? (' + fileName + ')', function (index) {
            console.log('Do you want to override the following file: ' + fileName + ' (' + index + ')')
            switch (index) {
              case 1: // No
                console.log('No. Returning to idle state.')
                break
              case 2: // Yes -> overrides  the file
                console.log('Yes. Overriding file.')
                directoryEntryReference.getFile(fileName, { create: true, exclusive: false }, function (fileEntry) {
                  fileEntry.createWriter(function (fileWriter) {
                    fileWriter.onwriteend = function (e) {
                      success(e.target.localURL, fileType, fileName)
                    }
                    fileWriter.onerror = function (e) {
                      error()
                    }
                    let blob = b64toBlob(data.replace(/^data:\w+\/\w+;base64,/, ''), fileType)
                    fileWriter.write(blob)
                  }, (e, file) => {
                  })
                }, (e, file) => {
                })
                break
            }
          }, 'Information', ['No', 'Yes'])
        })
      }, (e, file) => { // error resolveLocalFileSystemURL
      })
      /* eslint-enable no-undef */
    },
    showPain001View (record) {
      return (record.status === status.ORDER_GENERATED || record.status === status.INST_ORDER_GENERATED)
    },
    view: function (id) {
      // Get cloudDocument
      // var resource = 'attachment/detail/' + id
      const that = this
      this.$f7.showPreloader('Opening File')
      this.$engine.services.payments.getAttachmentDetail(id)
        .then(response => {
          this.$engine.settings.set({Attachment: {
            data: response.data.documentData,
            name: response.data.documentName,
            mimeType: response.data.documentData.split(';')[0].replace(/^data:/, ''),
            id: id
          }})
          if (that.$f7.device.os === 'android' || that.$f7.device.os === 'ios') {
            that.writeToFile(
              response.data.documentName,
              response.data.documentData,
              response.data.documentData.split(';')[0].replace(/^data:/, ''),
              true,
              function (filePath, fileType, fileName) {
                that.readFile(filePath, fileType, fileName)
              },
              function () {
                that.$f7.alert('', 'Error creating the file')
              }
            )
          } else {
            let blob = b64toBlob(response.data.documentData.split(',')[1], response.data.documentData.split(';')[0].replace(/^data:/, ''))
            const url = window.URL.createObjectURL(blob)
            const fileLink = document.createElement('a')
            fileLink.href = url
            fileLink.setAttribute('download', response.data.documentName) // or any other extension
            fileLink.click()
          }
          setTimeout(function () { that.$f7.hidePreloader() }, 1000)
        })
        .catch(error => {
          that.$f7.hidePreloader()
          errorMessageAlert(error, that)
          // errorMessageAlert(error, that)
        })
    },
    viewXML: function () {
      const that = this
      this.$f7.showPreloader(that.$i18n.t('common.opnng_fl'))
      // let userId = that.$engine.user.get().id
      // this.$engine.services.getEnvelope(idMessage, typeMessage, userId)
      this.$engine.services.getXMLDetail('directPayment', 'pain001', this.invoice.endToEndId)
        .then(response => {
          that.$f7.hidePreloader()
          this.$engine.settings.set({type: {
            data: response.data
          }})
          /* TLV 22/09/2020
          * Lignes ci-dessous a decommenter quand on testera le telechargement de
          * fichiers sur mobile */
          /* if (that.$f7.device.os === 'android' || that.$f7.device.os === 'ios') {
            that.writeToFile(
              typeMessage + '_' + idMessage + '.xml',
              response.data.data,
              response.data.data.split(';')[0].replace(/^data:/, ''),
              true,
              function (filePath, fileType, fileName) {
                that.readFile(filePath, fileType, fileName)
              },
              function () {
                that.$f7.alert('', 'Error creating the file')
              }
            )
          } else { */ // browser
          /* let blob = base64url.decode(response.data['envelopes'][0].message)
          const linkSource = 'data:text/csv;charset:utf-8,' + blob */
          let blob = b64toBlob(response.data.data.split(',')[1], 'text/xml')
          const linkSource = window.URL.createObjectURL(blob)
          const fileLink = document.createElement('a')
          fileLink.href = linkSource
          let today = moment().format()
          fileLink.setAttribute('download', 'Technical_View' + today + '.xml') // or any other extension
          fileLink.click()
          // }
        })
        .catch(error => {
          that.$f7.hidePreloader()
          console.log(error)
        })
    },
    writeToFile (fileName, data, fileType, readonly, success, error) {
      /* eslint-disable no-undef */
      let that = this
      let directory = ''

      if (readonly) {
        if (that.$f7.device.os === 'android') {
          directory = cordova.file.externalDataDirectory
        } else if (that.$f7.device.os === 'ios') {
          directory = cordova.file.tempDirectory
        } else {
          directory = cordova.file.dataDirectory
        }
        that.saveFileToDirectory(fileName, data, fileType, directory, success, error)
      } else {
        // directory = cordova.file.externalRootDirectory
        if (that.$f7.device.os === 'android') {
          directory = cordova.file.externalRootDirectory
        } else if (that.$f7.device.os === 'ios') {
          // directory = cordova.file.dataDirectory
          directory = cordova.file.tempDirectory
        } else {
          directory = cordova.file.dataDirectory
        }
        try {
          that.checkForWritePermissions(function () {
            try {
              window.resolveLocalFileSystemURL(directory, function (directoryEntry) {
                directoryEntry.getDirectory('Download', {create: true}, function (downloadDir, _data) {
                  that.saveFileToDirectory(fileName, data, fileType, downloadDir.nativeURL, function (filePath, fileType) {
                    console.log('sucess saving file: ', filePath)
                  }, function (error, _data) {
                    console.error('error on saving file' + error.code)
                    alert('Unable to save file: ' + error.code)
                  })
                }, function (error, _data) {
                  console.error('error on accessing download directory' + error.code)
                  alert('Unable to get/create download directory: ' + error.code)
                })
              }, (e, file) => { // error resolveLocalFileSystemURL
              })
            } catch (error) { // get dir
              console.error(error)
            }
          }, function () {
            alert('App needs access to the phone\'s file storage in order to save files.')
          })
        } catch (error) { // get perms
          console.error(error)
        }
      }
      /* eslint-enable no-undef */
    }
  }
}
</script>

<style>
#inst-payment-opt > .custom-control.custom-checkbox > label {
  cursor: default;
}
</style>
